import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=6b535956&scoped=true"
import script from "./Patients.vue?vue&type=script&lang=js"
export * from "./Patients.vue?vue&type=script&lang=js"
import style0 from "./Patients.vue?vue&type=style&index=0&id=6b535956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b535956",
  null
  
)

export default component.exports